export default __webpack_public_path__ + "static/media/flex_bg.ce5adc95.png";